// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../shared/images/Chat/telegram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../shared/images/Chat/viber.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../../shared/images/Chat/vk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../../shared/images/Chat/widget.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../../shared/images/Chat/facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../../shared/images/Chat/wechat.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../../shared/images/Chat/instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./../../shared/images/Chat/uniformwidget.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./../../shared/images/Chat/whatsapp-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./../../shared/images/Chat/voice-channel-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../../shared/images/Chat/telegram_private.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./../../shared/images/Chat/sendPulse.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    position: absolute;
    width: 46rem;
    height: 100%;
    right: 8.2rem;
    background-color: rgb(238, 238, 238);
    text-align: left;
    padding: 3.6rem 5.4rem;
    line-height: 3.6rem;
    z-index: 550;
    overflow-x: hidden;
    overflow-y: auto;
}

.operator_list_container {
    font-size: medium;
    font-weight: 500;
    width: 35.2rem;
}

.operator_list_container td {
    padding: 0 5px;
    overflow: hidden;
    max-width: 1px;
    word-break: break-word;
    vertical-align: top;
}

.profile-container__profile-block {
    margin-bottom: 3rem;
}

.profile-container__channel-row {
    display: flex; 
    align-items: center; 
    width: 100%; 
}

.profile-container__profile-channel-name {
    margin-right: 1.8rem;
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    max-width: 95%; 
    display: block; 
}

.profile-container__profile-channel-type-container {
    display: flex;
    margin-right: 1.8rem;
}

.channel-type-img {
    width: 2.1rem;
    height: 2.1rem;
}

.profile-container__profile-channel-type-1 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.profile-container__profile-channel-type-2 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.profile-container__profile-channel-type-3 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.profile-container__profile-channel-type-4 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.profile-container__profile-channel-type-5 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.profile-container__profile-channel-type-6 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.profile-container__profile-channel-type-7 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.profile-container__profile-channel-type-8 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.profile-container__profile-channel-type-9 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.profile-container__profile-channel-type-10 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.profile-container__profile-channel-type-11 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.profile-container__profile-channel-type-12 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.profile-container__profile-channel-type-13 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.profile-container__filter-block {
    display: flex;
    align-items: center; 
    padding: 10px;
}

.profile-container__filter-block select {
    max-width: 40%;
    margin-left: 1rem;
    max-height:5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/ProfileDropdown/ProfileDropDown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gDAAuD;AAC3D;;AAEA;IACI,gDAAoD;AACxD;;AAEA;IACI,gDAAiD;AACrD;;AAEA;IACI,gDAAqD;AACzD;;AAEA;IACI,gDAAuD;AAC3D;;AAEA;IACI,gDAAqD;AACzD;;AAEA;IACI,gDAAwD;AAC5D;;AAEA;IACI,gDAA4D;AAChE;;AAEA;IACI,gDAA4D;AAChE;;AAEA;IACI,gDAA4D;AAChE;;AAEA;IACI,gDAAiE;AACrE;;AAEA;IACI,iDAA+D;AACnE;;AAEA;IACI,iDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".profile-container {\r\n    position: absolute;\r\n    width: 46rem;\r\n    height: 100%;\r\n    right: 8.2rem;\r\n    background-color: rgb(238, 238, 238);\r\n    text-align: left;\r\n    padding: 3.6rem 5.4rem;\r\n    line-height: 3.6rem;\r\n    z-index: 550;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n\r\n.operator_list_container {\r\n    font-size: medium;\r\n    font-weight: 500;\r\n    width: 35.2rem;\r\n}\r\n\r\n.operator_list_container td {\r\n    padding: 0 5px;\r\n    overflow: hidden;\r\n    max-width: 1px;\r\n    word-break: break-word;\r\n    vertical-align: top;\r\n}\r\n\r\n.profile-container__profile-block {\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n.profile-container__channel-row {\r\n    display: flex; \r\n    align-items: center; \r\n    width: 100%; \r\n}\r\n\r\n.profile-container__profile-channel-name {\r\n    margin-right: 1.8rem;\r\n    white-space: nowrap; \r\n    overflow: hidden; \r\n    text-overflow: ellipsis; \r\n    max-width: 95%; \r\n    display: block; \r\n}\r\n\r\n.profile-container__profile-channel-type-container {\r\n    display: flex;\r\n    margin-right: 1.8rem;\r\n}\r\n\r\n.channel-type-img {\r\n    width: 2.1rem;\r\n    height: 2.1rem;\r\n}\r\n\r\n.profile-container__profile-channel-type-1 {\r\n    content: url(\"./../../shared/images/Chat/telegram.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-2 {\r\n    content: url(\"./../../shared/images/Chat/viber.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-3 {\r\n    content: url(\"./../../shared/images/Chat/vk.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-4 {\r\n    content: url(\"./../../shared/images/Chat/widget.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-5 {\r\n    content: url(\"./../../shared/images/Chat/facebook.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-6 {\r\n    content: url(\"./../../shared/images/Chat/wechat.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-7 {\r\n    content: url(\"./../../shared/images/Chat/instagram.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-8 {\r\n    content: url(\"./../../shared/images/Chat/uniformwidget.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-9 {\r\n    content: url(\"./../../shared/images/Chat/whatsapp-logo.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-10 {\r\n    content: url(\"./../../shared/images/Chat/whatsapp-logo.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-11 {\r\n    content: url(\"./../../shared/images/Chat/voice-channel-logo.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-12 {\r\n    content: url(\"./../../shared/images/Chat/telegram_private.svg\");\r\n}\r\n\r\n.profile-container__profile-channel-type-13 {\r\n    content: url(\"./../../shared/images/Chat/sendPulse.svg\");\r\n}\r\n\r\n.profile-container__filter-block {\r\n    display: flex;\r\n    align-items: center; \r\n    padding: 10px;\r\n}\r\n\r\n.profile-container__filter-block select {\r\n    max-width: 40%;\r\n    margin-left: 1rem;\r\n    max-height:5rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
